import AdminOrders from "@/pages/AdminOrders/AdminOrders";

export default class AdminReturns extends AdminOrders {

    protected get isReturnsPage(): boolean {
        return true;
    }
}